import { Typography } from "@mui/material";
import { createFileRoute, redirect } from "@tanstack/react-router";
import { zodValidator } from "@tanstack/zod-adapter";
import Page from "@/components/Page";
import StateTable from "@/components/State/StateTable";
import { buildFilterSearchState } from "@/hooks/Filter";
import { type StateFilters, stateSearchSchema } from "@/schemas/stateSearch";
import { getSavedFilters, hasActiveStateFilters } from "@/utils/filterPersistence";

function Maintenance() {
  return (
    <Page contentPadding maxWidth="xl">
      <Typography align="center" sx={{ my: 3 }} variant="h1">
        Tilstand
      </Typography>
      <StateTable />
    </Page>
  );
}

export const Route = createFileRoute("/_auth/tilstand")({
  component: Maintenance,
  validateSearch: zodValidator(stateSearchSchema),
  // Could the same validator as for map be used here? a lot of overlap.
  beforeLoad: (props) => {
    // Only restore on route entry, not on in-page filter changes ("stay") or preloads.
    if (props.cause === "stay" || props.cause === "preload") return;
    // Use the Zod-validated search to check for active filters.
    // Checking location.searchStr doesn't work: Zod's .default() always injects "state"
    // into the URL (via _includeValidateSearch:true), so the string check always returns
    // true and the restore is silently skipped. Kart avoids this by using .optional().
    if (hasActiveStateFilters(props.search.state)) return;
    const saved = getSavedFilters("tilstand");
    if (saved) {
      const filterState = buildFilterSearchState(
        stateSearchSchema.parse({}).state as Record<string, unknown>,
        saved,
      );
      if (hasActiveStateFilters(filterState as StateFilters)) {
        throw redirect({
          to: "/tilstand",
          search: { state: filterState as StateFilters },
          replace: true,
        });
      }
    }
  },
});
